import { ReactNode, useState } from "react"
import { Spinner } from "reactstrap"
import { ChevronDownIcon, ChevronRightIcon } from "Components/atoms/icons"

interface KpiCardProps {
    title: string
    subtitle?: ReactNode
    actions?: ReactNode
    isLoading: boolean
    children: ReactNode
}

// One container of Financial KPI Metrics: a collapsible section with its own spinner.
const KpiCard = ({ title, subtitle, actions, isLoading, children }: KpiCardProps) => {
    const [open, setOpen] = useState(true)
    return (
        <div className="section-container">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
                <div className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }} onClick={() => setOpen(o => !o)}>
                    {open ? <ChevronDownIcon /> : <ChevronRightIcon />}
                    <h5 className="mb-0">{title}</h5>
                    {subtitle && <small className="text-muted">{subtitle}</small>}
                </div>
                {actions && <div className="d-flex align-items-center gap-2">{actions}</div>}
            </div>
            {open && (isLoading ? <div className="text-center my-4"><Spinner /></div> : children)}
        </div>
    )
}

export default KpiCard
